/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Phase_4_DescriptionInputs */

const en_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete challenges to strengthen your focus and unlock a new tree.`)
};

const ar_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكمل التحديات لتعزيز تركيزك وفتح شجرة جديدة.`)
};

const de_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließe Herausforderungen ab, um deinen Fokus zu stärken und einen neuen Baum freizuschalten.`)
};

const es_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa desafíos para fortalecer tu concentración y desbloquear un nuevo árbol.`)
};

const fr_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relevez des défis pour renforcer votre concentration et débloquez un nouvel arbre.`)
};

const it_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa le sfide per rafforzare la tua concentrazione e sbloccare un nuovo albero.`)
};

const ja_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チャレンジを達成して集中力を鍛え、新しい木をアンロックしましょう。`)
};

const ko_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`챌린지를 완료하여 집중력을 강화하고 새로운 나무를 획득하세요.`)
};

const pt_br_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conclua desafios para fortalecer seu foco e desbloquear uma nova árvore.`)
};

const ru_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выполняйте задания, чтобы улучшить концентрацию и разблокировать новое дерево.`)
};

const th_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำความท้าทายให้เสร็จสิ้นเพื่อเสริมความแข็งแกร่งในการโฟกัสและปลดล็อกต้นไม้ใหม่`)
};

const tr_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanmanı güçlendirmek ve yeni bir ağacın kilidini açmak için görevleri tamamla.`)
};

const zh_cn_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成挑战来强化你的专注力，并解锁新树作为奖励！`)
};

const zh_tw_starter_challenge_phase_4_description = /** @type {(inputs: Starter_Challenge_Phase_4_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完成挑戰來強化你的專注力，並解鎖新樹作為獎勵！`)
};

/**
* | output |
* | --- |
* | "Complete challenges to strengthen your focus and unlock a new tree." |
*
* @param {Starter_Challenge_Phase_4_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_phase_4_description = /** @type {((inputs?: Starter_Challenge_Phase_4_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Phase_4_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_phase_4_description(inputs)
	if (locale === "ar") return ar_starter_challenge_phase_4_description(inputs)
	if (locale === "de") return de_starter_challenge_phase_4_description(inputs)
	if (locale === "es") return es_starter_challenge_phase_4_description(inputs)
	if (locale === "fr") return fr_starter_challenge_phase_4_description(inputs)
	if (locale === "it") return it_starter_challenge_phase_4_description(inputs)
	if (locale === "ja") return ja_starter_challenge_phase_4_description(inputs)
	if (locale === "ko") return ko_starter_challenge_phase_4_description(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_phase_4_description(inputs)
	if (locale === "ru") return ru_starter_challenge_phase_4_description(inputs)
	if (locale === "th") return th_starter_challenge_phase_4_description(inputs)
	if (locale === "tr") return tr_starter_challenge_phase_4_description(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_phase_4_description(inputs)
	return zh_tw_starter_challenge_phase_4_description(inputs)
});